// extracted by mini-css-extract-plugin
module.exports = {"root":"Grid_root__1N00H","grid":"Grid_grid__3evHu"};